import React from 'react';
import '../less/defenceEveryDay.less';
import FAQStorybook from '@abank/abank-faq';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import advantagesItemsData from '../enums/advantages_items.json';
import additionalCards from '../enums/additional_cards_data.json';
import insurerInfoDataConfig from '../enums/insurer_info_data.json';
import intermediaryTariffsData from '../enums/intermediary_tariffs_data.json';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import { insuranceIntermediaryInfoArsenalLink, insuranceIntermediaryInfoArxlifeLink, insuranceIntermediaryInfoArxLink, insuranceIntermediaryInfoEiaLink, insuranceIntermediaryInfoEuroinsLink, insuranceIntermediaryInfoEurotravelinsLink, insuranceIntermediaryInfoIngoLink, insuranceIntermediaryInfoInterexpressLink, insuranceIntermediaryInfoInterpolicyLink, insuranceIntermediaryInfoKniazhaLink, insuranceIntermediaryInfoOrantaLink, insuranceIntermediaryInfoPzuLink, insuranceIntermediaryInfoRespectinsLink, insuranceIntermediaryInfoSgtasLink, insuranceIntermediaryInfoTaslifeLink, insuranceIntermediaryInfoUkringroupLink, insuranceIntermediaryInfoUniqaLink, insuranceIntermediaryInfoUniversalnaLink,insuranceIntermediaryInfoUticoLink, insuranceIntermediaryInfoVusoLink, insuranceDocumentsTasPrivateCompanyLink, insuranceDocumentsMetlifeCompanyLink, insuranceIntermediaryInfoMetlifeLink, insuranceDefenceeverydayDocumentsTasPrivateProductLink, insuranceDefenceeverydayDocumentsMetlifeProductLink } from '../../../../../services/urls/urls';
import { Preloader } from 'MWComponents';
import intermediaryInfoDataConfig from '../enums/intermediary_info_data.json';
import InsuranceIntermediaryInfo from '../../../../../auxiliary-components/shared/InsuranceIntermediaryInfo';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import QuestionsFullAdmin from '../../../../../auxiliary-components/shared/QuestionsFullAdmin';
import { mapInsuranceDetailedInfoToTariffs } from './../../../../../helpers/utils/mapInsuranceDetailedInfoToTariffs';
import InfoBlock from './../../../../../auxiliary-components/shared/InfoBlock/index';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';
import { canUseDOM } from '../../../../../helpers/canUseDOM';

export default function template() {
  const page = "defence-every-day-new";

  const tabs = [{tab: 'insurer-info', title: 'DEFENCE_EVERY_DAY_NEW_TABS_TITLE_01'},
        {tab: 'partners', title: 'DEFENCE_EVERY_DAY_NEW_TABS_TITLE_02'},
        {tab: 'insurance-info', title: 'DEFENCE_EVERY_DAY_NEW_TABS_TITLE_03'},
        {tab: 'intermediary-info', title: 'DEFENCE_EVERY_DAY_NEW_TABS_TITLE_04'}];
  
  const tabsShortInsuranceInfo= [{tab: 'tas-short', title: 'DEFENCE_EVERY_DAY_NEW_TABS_INSURANCE_INFO_TITLE_01'},
                {tab: 'metlife-short', title: 'DEFENCE_EVERY_DAY_NEW_TABS_INSURANCE_INFO_TITLE_02'}];

  const tabsFullInsuranceInfo = [{tab: 'tas-full', title: 'DEFENCE_EVERY_DAY_NEW_TABS_INSURANCE_INFO_TITLE_01'},
                {tab: 'metlife-full', title: 'DEFENCE_EVERY_DAY_NEW_TABS_INSURANCE_INFO_TITLE_02'}];

  const imagesMap = {
    advantages_img_1,
    advantages_img_2,
    advantages_img_3,
    advantages_img_4
  };

  const linksMap = { insuranceIntermediaryInfoArxLink, insuranceIntermediaryInfoVusoLink,insuranceIntermediaryInfoUniversalnaLink, insuranceIntermediaryInfoUniqaLink, insuranceIntermediaryInfoEiaLink,insuranceIntermediaryInfoEurotravelinsLink, insuranceIntermediaryInfoArsenalLink, insuranceIntermediaryInfoEuroinsLink, insuranceIntermediaryInfoIngoLink, insuranceIntermediaryInfoInterexpressLink, insuranceIntermediaryInfoInterpolicyLink, insuranceIntermediaryInfoOrantaLink, insuranceIntermediaryInfoPzuLink, insuranceIntermediaryInfoRespectinsLink, insuranceIntermediaryInfoSgtasLink, insuranceIntermediaryInfoUkringroupLink, insuranceIntermediaryInfoUticoLink, insuranceIntermediaryInfoArxlifeLink, insuranceIntermediaryInfoKniazhaLink, insuranceIntermediaryInfoTaslifeLink, insuranceDocumentsTasPrivateCompanyLink, insuranceDocumentsMetlifeCompanyLink, insuranceIntermediaryInfoMetlifeLink, insuranceDefenceeverydayDocumentsTasPrivateProductLink, insuranceDefenceeverydayDocumentsMetlifeProductLink };

  const intermediaryInfoData = intermediaryInfoDataConfig.map(item => {
    if (item.type === 'companies' && item.companies) {
      return {
        ...item,
        companies: item.companies.map(company => ({
          ...company,
          link: linksMap[company.link]
        }))
      };
    }
    return {
      ...item
    };
  });

  const insurerInfoData = insurerInfoDataConfig.map(item => ({
    ...item,
    values: item.values.map(val => {
      if (val.type === 'button') {
        return {
          ...val,
          btnLink: linksMap[val.btnLink],
        };
      }

      return val;
    }),
  }));

  const hero_data = {
    title: "DEFENCE_EVERY_DAY_NEW_HERO_TITLE",
    text: "DEFENCE_EVERY_DAY_NEW_HERO_TEXT"
  }
  
  const advantagesItems = advantagesItemsData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');
  const partnersWidget = this.widgetsHelper.getWidget.call(this, 'partners');
  
  const detailedInsuranceInfoWidgets = [
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoTasWidget', 'questions'), loadingKey: 'detailedInfoTasWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoMetlifeWidget', 'questions'), loadingKey: 'detailedInfoMetlifeWidget_loading'}
  ];

  return (
    <div className="defence-every-day-new">
      <Hero
        data={hero_data}
        img={hero_img}
      />
      <div className={`content${(this.state.faqTab || this.state.detailedInsuranceInfoTab || this.state.intermediaryInsuranceInfoTab) ? ' hidden' : ''}`}>
        <div>
          <div className="general-info">
            <div className="container">
              <h2 className="general-info__title">{this.l10n('DEFENCE_EVERY_DAY_NEW_GENERAL_INFO_TITLE')}</h2>
              <div className="general-info__text">
                <p>{this.l10n('DEFENCE_EVERY_DAY_NEW_GENERAL_INFO_TEXT_01')}</p>
                <p>{this.l10n('DEFENCE_EVERY_DAY_NEW_GENERAL_INFO_TEXT_02')}</p>
                <ul>
                  <li>{this.l10n('DEFENCE_EVERY_DAY_NEW_GENERAL_INFO_LIST_01')}</li>
                  <li>{this.l10n('DEFENCE_EVERY_DAY_NEW_GENERAL_INFO_LIST_02')}</li>
                  <li>{this.l10n('DEFENCE_EVERY_DAY_NEW_GENERAL_INFO_LIST_03')}</li>
                  <li>{this.l10n('DEFENCE_EVERY_DAY_NEW_GENERAL_INFO_LIST_04')}</li>
                </ul>
              </div>
            </div>
          </div>
          <InfoBlock
            title={'DEFENCE_EVERY_DAY_NEW_INFO_TITLE'}
            text={'DEFENCE_EVERY_DAY_NEW_INFO_TEXT'}
          />
        </div>
        <Advantages
          items={advantagesItems}
          title={'DEFENCE_EVERY_DAY_NEW_ADVANTAGES_TITLE'}
        />
        <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab}>
          <Tariffs
            items={insurerInfoData}
            title={'DEFENCE_EVERY_DAY_TARIFFS_INSURER_INFO_TITLE'}
            titleTag={"div"}
          />
          {this.state.loader ? (canUseDOM ? <Preloader/> : null) : (partnersWidget && partnersWidget.data && partnersWidget.data.length > 0 ? (
            <div className="partners">
              <div className="container">
                <div className="partners__body">
                  {partnersWidget.data.sort((a, b) => a.order - b.order).map((item, index) => (
                  <div className="partners__item" key={index}>
                    <img className="partners__image" src={item.img_desktop} alt="partners image"/>
                  </div>
                ))}
                </div>
              </div>
            </div>
          ) : null)}
          <Tabs tabs={tabsShortInsuranceInfo} toggle={this.toggleShortInsuranceInfoTab} tab={this.state.tabShortInsuranceInfo} title={'DEFENCE_EVERY_DAY_NEW_TABS_TITLE'}>
            {detailedInsuranceInfoWidgets.map(({widget, loadingKey}, index) => {
              const detailedInfoTariffsItems = mapInsuranceDetailedInfoToTariffs(widget);

              if (this.state[loadingKey]) {
                return canUseDOM ? <Preloader key={index}/> : null;
              }

              if (detailedInfoTariffsItems && detailedInfoTariffsItems.length > 0) {
                return (
                  <Tariffs
                    key={index}
                    items={detailedInfoTariffsItems}
                    alignItems="start"
                    onBtnClick={this.toggleDetailedInsuranceInfoTab}
                    btnText={'DEFENCE_EVERY_DAY_NEW_TARIFFS_INSURANCE_INFO_BTN'}
                    insuranceInfo
                  />
                );
              }

              return null;
            })}
          </Tabs>
          <Tariffs
            items={intermediaryTariffsData}
            title={'DEFENCE_EVERY_DAY_NEW_TARIFFS_INTERMEDIARY_INFO_TITLE'}
            alignItems="start"
            onBtnClick={this.toggleIntermediaryInsuranceInfoTab}
            btnText={'DEFENCE_EVERY_DAY_NEW_TARIFFS_INTERMEDIARY_INFO_BTN'}
          />
        </Tabs>
        <AdditionalProduct
          items={additionalCards}
          title={'DEFENCE_EVERY_DAY_NEW_ADDITIONAL_PRODUCT_TITLE'}
        />
        <QuestionsAdminNew
          widget={questionsWidget}
          toggleFaqTab={this.toggleFaqTab}
          title={'DEFENCE_EVERY_DAY_NEW_QUESTIONS_TITLE'}
          loader={this.state.loader}
        />
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('DEFENCE_EVERY_DAY_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('DEFENCE_EVERY_DAY_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
      <div className={`content${!this.state.detailedInsuranceInfoTab ? ' hidden' : ''}`}>
        <div>
          <div className="insurance-detailed-info">
            <div className="container">
              <div className="insurance-detailed-info__top">
                <h2 className="insurance-detailed-info__title">{this.l10n('DEFENCE_EVERY_DAY_NEW_DETAILED_INFO_TITLE')}</h2>
                <button className="insurance-detailed-info__btn" onClick={this.toggleDetailedInsuranceInfoTab}>{this.l10n('DEFENCE_EVERY_DAY_NEW_DETAILED_INFO_BTN')}</button>
              </div>
            </div>
          </div>
          <Tabs tabs={tabsFullInsuranceInfo} toggle={this.toggleFullInsuranceInfoTab} tab={this.state.tabFullInsuranceInfo}>
            {detailedInsuranceInfoWidgets.map(({widget, loadingKey}, index) => (
              <QuestionsFullAdmin
                key={index}
                widget={widget}
              />
            ))}
          </Tabs>
        </div>
      </div>
      <div className={`content${!this.state.intermediaryInsuranceInfoTab ? ' hidden' : ''}`}>
        <InsuranceIntermediaryInfo
          items={intermediaryInfoData}
          title={'DEFENCE_EVERY_DAY_NEW_INTERMEDIARY_INFO_TITLE'}
          onBtnClick={this.toggleIntermediaryInsuranceInfoTab}
          btnText={'DEFENCE_EVERY_DAY_NEW_INTERMEDIARY_INFO_BTN'}
        />
      </div>
    </div>
  )
}
